module.exports = __webpack_public_path__ + "static/media/Axle spacing.3c55bb6c.JPG";